import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ENV_CONFIG } from '@bn/primitives';

import { ClientInfo } from '../models/client-info.model';

@Injectable({
  providedIn: 'root',
})
export class UtilApiService {
  readonly #ENV_CONFIG = inject(ENV_CONFIG);
  readonly #httpClient = inject(HttpClient);
  readonly #apiUrl!: string;

  constructor() {
    this.#apiUrl = `${this.#ENV_CONFIG.apiUrl}/util`;
  }

  public getClientInfo(): Observable<ClientInfo> {
    return this.#httpClient.get<ClientInfo>(`${this.#apiUrl}/clientinfo`);
  }
}
